import { memo, useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { documentHotkeysSelector } from '@/domain/documents/documentSelector';
import { journalSelector, selectedRowSelector } from '@/domain/journal';
import { hotkeyMatcher } from '@/lib/hotkeysHelpers';

import { HotkeyCellListFactory, HotkeyMatchFactory } from '@/domain/documents/factories';
import { RecordCellSet } from '@/domain/journal/helper';

const LineHotkeyCatcher = ({ hotkeys, selectedRows, cellsEntry, handleHotkeyMatch }) => {
  const lineHotkeys = useMemo(() => hotkeys.filter((keys) => keys.level === 'line'), [hotkeys]);

  const onHotkeyMatch = useCallback(
    (keys) => {
      const selectedCells = selectedRows.map((row) => `A${row}`);
      const cellList = selectedCells.map((_cell) => {
        const cellEntry = cellsEntry.get(_cell);

        return HotkeyCellListFactory({
          set: RecordCellSet(cellEntry.cellSet),
          name: cellEntry.name,
          cell: _cell,
        });
      });

      // for keyboard shortcuts it doesn't matter which cell passed to update field,
      // back-end skip update Field if hotkey Field is exist
      const plugCell = cellList.first();

      handleHotkeyMatch(
        plugCell.get('cell'),
        plugCell.get('set'),
        false,
        HotkeyMatchFactory({ cell_list: cellList, key: keys }),
      );
    },
    [selectedRows, cellsEntry, handleHotkeyMatch],
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (selectedRows.size > 0) {
        const isMatch = hotkeyMatcher(e, lineHotkeys, onHotkeyMatch);

        if (isMatch) {
          e.preventDefault();
        }
      }
    },
    [lineHotkeys, selectedRows, onHotkeyMatch],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [lineHotkeys, selectedRows, handleKeyDown]);

  return null;
};

const mapStateToProps = (state) => ({
  hotkeys: documentHotkeysSelector(state),
  selectedRows: selectedRowSelector(state),
  cellsEntry: journalSelector(state),
});

export default compose(connect(mapStateToProps))(memo(LineHotkeyCatcher));
